// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modal Overlay */
.modal.show {
  display: block;
  background-color: rgba(0, 0, 0, 0.5);
}

/* Modal Content - Dark Theme */
.modal-content {
  background-color: #2c2c2c !important;
  color: #e0e0e0 !important;
}

/* Modal Header */
.modal-header {
  border-bottom: 1px solid #444 !important;
}

.modal-title {
  color: #e0e0e0 !important;
}

/* Modal Body */
.modal-body {
  color: #d0d0d0 !important;
}

.modal-body a {
  color: #66b3ff !important;
}

.modal-body a:hover {
  color: #99ccff !important;
  text-decoration: underline;
}

/* Modal Footer */
.modal-footer {
  border-top: 1px solid #444 !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/modals/Modal.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA,+BAA+B;AAC/B;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,qCAAqC;AACvC","sourcesContent":["/* Modal Overlay */\n.modal.show {\n  display: block;\n  background-color: rgba(0, 0, 0, 0.5);\n}\n\n/* Modal Content - Dark Theme */\n.modal-content {\n  background-color: #2c2c2c !important;\n  color: #e0e0e0 !important;\n}\n\n/* Modal Header */\n.modal-header {\n  border-bottom: 1px solid #444 !important;\n}\n\n.modal-title {\n  color: #e0e0e0 !important;\n}\n\n/* Modal Body */\n.modal-body {\n  color: #d0d0d0 !important;\n}\n\n.modal-body a {\n  color: #66b3ff !important;\n}\n\n.modal-body a:hover {\n  color: #99ccff !important;\n  text-decoration: underline;\n}\n\n/* Modal Footer */\n.modal-footer {\n  border-top: 1px solid #444 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
